import React, { useEffect } from 'react';
import { Redirect, Route } from 'react-router';
import PropTypes from 'prop-types';
import { authScopeStringGetHelper } from '../../util/helpers/authScopeHelpers';
import { JWT_TOKEN } from '../../constants/localStorage';
import { BUY_PAGE } from '../../constants/pages';
import { landingPageHelper } from '../../util/helpers/landingPageHelper';
import { storeInSessionStorage } from '../../util/helpers/sessionStorageHelper';
import {
  QUICK_BUY_PRODUCT,
  QUICK_REGISTRATION,
} from '../../constants/sessionStorage';

const RegistrationRoute = ({ ...props }) => {
  const jwtToken = authScopeStringGetHelper(JWT_TOKEN);
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const { productCode } = params;

  useEffect(() => {
    if (productCode) {
      storeInSessionStorage(QUICK_REGISTRATION, true);
      storeInSessionStorage(QUICK_BUY_PRODUCT, productCode);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  const redirect = () => {
    if (jwtToken) {
      if (productCode) {
        return (
          <Redirect
            to={{
              pathname: BUY_PAGE,
              state: {
                productCode,
              },
            }}
          />
        );
      }

      return (
        <Redirect
          to={{
            pathname: landingPageHelper(),
          }}
        />
      );
    }
    return <Route {...props} />;
  };
  return redirect();
};

RegistrationRoute.propTypes = {
  path: PropTypes.string,
};

export default RegistrationRoute;
